type XlsxModule = typeof import('xlsx')

let xlsxModulePromise: Promise<XlsxModule> | undefined
let xlsxWithCodepageModulePromise: Promise<XlsxModule> | undefined

/**
 * Use for modern XLSX files and other inputs that do not require legacy character-encoding tables.
 */
export function loadXlsx(): Promise<XlsxModule> {
  if (!xlsxModulePromise) {
    xlsxModulePromise = import('xlsx').catch(error => {
      xlsxModulePromise = undefined
      throw error
    })
  }

  return xlsxModulePromise
}

/**
 * Use for legacy or text-based XLS inputs, such as SAP exports, whose encoding must be decoded with cpexcel.
 * Keep modern XLSX imports on loadXlsx() so they do not download the additional codepage chunk.
 */
export function loadXlsxWithCodepage(): Promise<XlsxModule> {
  if (!xlsxWithCodepageModulePromise) {
    xlsxWithCodepageModulePromise = Promise.all([loadXlsx(), import('xlsx/dist/cpexcel.full.mjs')])
      .then(([xlsx, cptable]) => {
        xlsx.set_cptable(cptable)
        return xlsx
      })
      .catch(error => {
        xlsxWithCodepageModulePromise = undefined
        throw error
      })
  }

  return xlsxWithCodepageModulePromise
}
